/**
 * Module: search-window.js
 * Search Window JavaScript Controller
 */

export default (enableDebug = false) => {
	const trigger = document.getElementById('js-header-search-toggle');
	const searchWindow = document.getElementById('searchWindow');
	const body = document.querySelector('body');

	const toggleWindow = () => {
		if (!searchWindow || !trigger || !body) return;

		searchWindow.classList.toggle('--is-active');
		trigger.classList.toggle('--is-active');
		body.classList.toggle('--search-is-open');

		const header = document.getElementById('header');
		if (header && header.classList.contains('--is-opened')) {
			const toggle = document.querySelector('.main-menu__toggle');
			if (toggle) toggle.click();
		}
	};

	const searchType = () => {
		const windowContainer = document.getElementById('searchWindow');
		if (!windowContainer) return;

		const parent = windowContainer.querySelector('.search-toggle__search-type__parent');
		const childrenEl = windowContainer.querySelector('.search-window__search-type__children');
		const container = parent ? parent.closest('.search-toggle__search-type') : null;

		if (!parent || !container) return;

		const radios = parent.querySelectorAll('input[type="radio"]');
		const fauxToggle = container.querySelector('#fauxToggle');
		const textFieldsContainer = windowContainer.querySelector('.search-window__text-fields');

		const updateTextFields = (value) => {
			if (!textFieldsContainer) return;
			const fields = textFieldsContainer.querySelectorAll('.search-window__text-field');

			fields.forEach(field => {
				field.classList.toggle('--is-active', field.getAttribute('rel') === value);
			});
		};

		const handleChange = (value) => {
			if (childrenEl) {
				childrenEl.classList.toggle('--is-active', value === 'resources');
			}
			updateTextFields(value);
		};

		parent.addEventListener('change', (e) => {
			if (e.target && e.target.type === 'radio') {
				radios.forEach(r => r.checked = false);
				e.target.checked = true;
				handleChange(e.target.value);
			}
		});

		if (fauxToggle) {
			fauxToggle.addEventListener('click', () => {
				const uncheckedRadio = [...radios].find(r => !r.checked);
				if (uncheckedRadio) {
					radios.forEach(r => r.checked = false);
					uncheckedRadio.checked = true;
					handleChange(uncheckedRadio.value);
				}
			});
		}
	};

	const bindSearchAnchors = () => {
		const anchors = document.querySelectorAll('.search-window .button--primary[href*="?s="]');
		console.debug('[bindSearchAnchors] Found', anchors.length, 'anchor(s)');

		anchors.forEach(anchor => {
			anchor.addEventListener('click', (e) => {
				e.preventDefault();
				const text = anchor.textContent.trim();
				console.debug('[bindSearchAnchors] Anchor clicked with text:', text);

				const activeField = document.querySelector('.search-window__text-field.--is-active');
				if (!activeField) {
					console.warn('[bindSearchAnchors] No active field found');
					return;
				}
				console.debug('[bindSearchAnchors] Found activeField:', activeField);

				const input = activeField.querySelector('input[type="text"]');
				if (!input) {
					console.warn('[bindSearchAnchors] No input found inside activeField');
					return;
				}
				console.debug('[bindSearchAnchors] Found input:', input);

				input.value = text;
				console.debug('[bindSearchAnchors] Set input value to:', input.value);

				const form = input.closest('form');
				if (!form) {
					console.warn('[bindSearchAnchors] No form found from input');
					return;
				}
				console.debug('[bindSearchAnchors] Found form:', form);

				if (typeof form.requestSubmit === 'function') {
					console.debug('[bindSearchAnchors] Submitting form via requestSubmit()');
					form.requestSubmit();
				} else {
					console.debug('[bindSearchAnchors] Submitting form via submit()');
					form.submit();
				}
			});
		});
	};

	searchType();

	if (trigger) {
		trigger.addEventListener('click', toggleWindow);
	}
	bindSearchAnchors();
};
